import { theme } from '@prophecy/theme';
import { Centered, Ellipsis, overlayStyle, Select, Stack, Text } from '@prophecy/ui-v3';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import { useImportState } from '../../useImportState';
import { FileTypes } from '../types';
import { getFileBrowserSearchViewData, getFileIconMap } from '../utils';

const StyledStack = styled(Stack)`
  span {
    display: inline-grid;
  }
`;

export const SearchFileBrowserView = ({
  paths,
  setSelectedPath,
  showFoldersOnly
}: {
  showFoldersOnly?: boolean;
  paths: string[];
  setSelectedPath: (path: string) => void;
}) => {
  const { loading } = useImportState();

  const FileIconMap = getFileIconMap();

  const [searchStr, setSearchStr] = useState('');

  const searchData = useMemo(
    () => getFileBrowserSearchViewData(paths, searchStr, showFoldersOnly),
    [paths, showFoldersOnly, searchStr]
  );

  return (
    <Select
      onSelect={setSelectedPath}
      onSearch={setSearchStr}
      loading={loading}
      defaultValue={null}
      value={null}
      placeholder='Search...'
      filterOption={false}
      virtual={true}
      showSearch={true}
      data-test-id='search-file-browser-view-select'
      aria-label='Search files'>
      {searchData.length === 0 && (
        <Select.Option value='nodata' disabled>
          <Stack width='100%' height='150px'>
            <Centered>No result found</Centered>
          </Stack>
        </Select.Option>
      )}
      {searchData.map((row) => {
        const fileType = row?.fileType as FileTypes;
        const icon = FileIconMap?.[fileType as keyof typeof FileIconMap];
        const textUI = (
          <Ellipsis
            tooltip={true}
            tooltipProps={{
              overlayStyle
            }}>
            {row.name}
          </Ellipsis>
        );
        return (
          <Select.Option value={row.path} key={row.path} name={row.name}>
            <Stack direction='horizontal' width='100%' gap={theme.spaces.x20}>
              <StyledStack direction='horizontal' alignY='center' width='35%' gap={theme.spaces.x4}>
                {icon ? icon : FileIconMap[FileTypes.others]}
                <Text level='sm' tone={theme.colors.gray900}>
                  {textUI}
                </Text>
              </StyledStack>
              <StyledStack width='60%'>
                <Text level='sm' tone={theme.colors.gray400}>
                  <Ellipsis
                    tooltip={true}
                    tooltipProps={{
                      overlayStyle
                    }}>
                    {row.path}
                  </Ellipsis>
                </Text>
              </StyledStack>
            </Stack>
          </Select.Option>
        );
      })}
    </Select>
  );
};
